import React from 'react';
import TouchableDiv from './TouchableDiv';
import './FigoInput.css';

const FigoInput = ({
  controlId,
  disabled = false,
  error = '',
  inputName,
  maxLength,
  onBlur,
  onChange,
  placeholder,
  renderError,
  title,
  value,
}) => (
  <div className="form-group">
    <TouchableDiv>
      {title && (
        <label className="form-label" htmlFor={controlId}>{title}</label>
      )}
    </TouchableDiv>

    <div className="input-group">
      <input
        className={'form-control FigoInput-input '
          + `${error && 'Input-error'} ${disabled && 'Input-disabled'}`}
        disabled={disabled}
        id={controlId}
        maxLength={maxLength}
        name={inputName}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
      />
    </div>

    {error && renderError && (
      <p className="Error-label">
        {renderError(error)}
      </p>
    )}
  </div>
);

export default FigoInput;
